import { render, staticRenderFns } from "./custserv.vue?vue&type=template&id=9b96a592&scoped=true&"
import script from "./custserv.vue?vue&type=script&lang=js&"
export * from "./custserv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b96a592",
  null
  
)

export default component.exports